import { render, staticRenderFns } from "./PageProduitsHorsMarche.vue?vue&type=template&id=6e0ce413&"
import script from "./PageProduitsHorsMarche.vue?vue&type=script&lang=js&"
export * from "./PageProduitsHorsMarche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e0ce413')) {
      api.createRecord('6e0ce413', component.options)
    } else {
      api.reload('6e0ce413', component.options)
    }
    module.hot.accept("./PageProduitsHorsMarche.vue?vue&type=template&id=6e0ce413&", function () {
      api.rerender('6e0ce413', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Commandes/PageProduitsHorsMarche.vue"
export default component.exports